import Plyr from 'plyr';
import 'plyr/dist/plyr.css';
import Hls from 'hls.js';

import { queryToAttrs } from '../common/utils';
import '../common/style.css';

const qs = new URLSearchParams(window.location.search.substring(1));
const params = queryToAttrs(qs);

const container = document.getElementById('player-container');
const video = document.createElement('video');
container.appendChild(video);

if (params['mux-playback-id']) {
  params.src = `https://stream.mux.com/${params['mux-playback-id']}.m3u8`
  video.poster = params.poster || `https://image.mux.com/${params['mux-playback-id']}/thumbnail.jpeg`;
}

//
// convert the 'controls' boolean query param into
// a 'controls' value that Plyr understands
//

if (params.controls === false) {
  params.controls = [];
}

if (params.controls === true) {
  delete params.controls
}

const player = new Plyr(video, params);

if (Hls.isSupported()) {
  var hls = new Hls();
  hls.loadSource(params.src);
  hls.attachMedia(video);
} else if (video.canPlayType('application/vnd.apple.mpegurl')) {
  video.src = params.src;
}
